<template>
    <div class="row content" v-if="finishedLoading">
        <div class="col-12 align-self-center text-center">
            <div class="item__tit animate">
                <h1 class="animated bounceIn">Olá, {{firstName}}!</h1>
                <p class="animated bounceIn">Vou te ajudar na sua simulação. Que tipo de empréstimo deseja?</p>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 animate">
                    <ul class="row justify-content-center">
                        <li class="col-12 col-md-4 animated fadeInDown">
                            <a href="/#/tipo-de-emprestimo/simulacao?type=EMPCOL" class="simulacao" title="Empréstimo coletivo">Empréstimo coletivo</a>
                            <a :href="lpUrl+'/lp/emprestimo-coletivo/'" class="saiba-mais" title="Saiba mais sobre Empréstimo coletivo" target="_blank" rel="product">Saiba mais</a>
                        </li>

                        <li class="col-12 col-md-4 animated fadeInDown">
                            <a href="/#/tipo-de-emprestimo/simulacao?type=EMPIMP2" class="simulacao" title="Empréstimo de impacto">Empréstimo de impacto</a>
                            <a :href="lpUrl+'/lp/emprestimo-de-impacto/'" class="saiba-mais" title="Saiba mais sobre Empréstimo de impacto" target="_blank" rel="product">Saiba mais</a>
                        </li>


                        <li class="col-12 col-md-4 animated fadeInDown" style="display: none;">
                            <a href="/#/tipo-de-emprestimo/solicitar-emprestimo?type=EMPSOC" class="simulacao" title="Empréstimo social">Empréstimo social</a>
                            <a :href="lpUrl+'/lp/emprestimo-social/'" class="saiba-mais" title="Saiba mais sobre Empréstimo Social" target="_blank" rel="product">Saiba mais</a>
                        </li>

                        <li class="col-12 col-md-4 animated fadeInDown" style="display: none;">
                            <a :href="LIZA_URL+'/base.html?valor=&pagina=emprestimo-pessoal&url=emp_pessoal'" class="simulacao" title="Empréstimo pessoal">Empréstimo pessoal</a>
                            <a :href="lpUrl+'/lp/emprestimo-pessoal/'" class="saiba-mais" title="Saiba mais sobre Empréstimo pessoal" target="_blank" rel="product">Saiba mais</a>
                        </li>
                        <li class="col-12 col-md-4 animated fadeInDown" style="display: none;">
                            <a :href="LIZA_URL+'/base.html?valor=&pagina=veiculo-em-garantia&url=emp_veiculo'" class="simulacao" title="Veículo em Garantia">Veículo em Garantia</a>
                            <a :href="lpUrl+'/lp/veiculo-em-garantia/'" class="saiba-mais" title="Saiba mais sobre Veículo em Garantia" target="_blank" rel="product">Saiba mais</a>
                        </li>
                        <li class="col-12 col-md-4 animated fadeInDown" style="display: none;">
                            <a :href="LIZA_URL+'/base.html?valor=&pagina=imovel-em-garantia&url=emp_imovel'" class="simulacao" title="Imóvel em Garantia">Imóvel em Garantia</a>
                            <a :href="lpUrl+'/lp/imovel-em-garantia/'" class="saiba-mais" title="Saiba mais sobre Imóvel em Garantia" target="_blank" rel="product">Saiba mais</a>
                        </li>
                    </ul>
                </div>
            </div>					
        </div>
    </div>	
</template>

<script>
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'

    export default {
        metaInfo: {
            htmlAttrs: {
                lang: 'pt-br'
            },
            bodyAttrs: {
                class: 'select-loan'
            }
        },
        data() {
            return {
                lpUrl:process.env.LP_URL,
                user: null,
                finishedLoading: false,
            }
        },
        computed: {
            firstName: function() {
                if(this.user.name){
                    return this.getFirstName(this.user.name);
                } else {
                    return this.getFirstName(this.user.username);
                }
            }
        },
        methods: {
            getFirstName(name) {
                let firstName = name.split(" ");

                return firstName[0];
            }
        },
        beforeCreate() {
            this.$store.commit(mutationTypes.START_LOADING)

            ApiClient.getUser()
            .then(response => {
                this.user = response;

                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
            .catch(() => {
                this.finishedLoading = true;
                this.$store.commit(mutationTypes.STOP_LOADING);
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/SelectLoanType.vue